import React from 'react';
import logo from './images/logo.webp';
import style from './index.scss';
import { Loader } from '@core/js/components/common/Loader';
import { Image } from '@core/js/components/common/Image';

import { useMobileRegistrationHeader } from './hooks/useMobileRegistrationHeader';

export const MobileRegistrationHeader = () => {
    const { registerTitle, onLoad, isImgLoading } = useMobileRegistrationHeader();

    return (
        <>
            <div className={style.placeholder}></div>
            <div className={`mobile-registration-header ${style.registerTitleContainer}`}>
                <div className={style.logoContainer}>
                    <Image src={logo} alt="Logo" onLoad={onLoad} className={style.logoImage} style={{ opacity: isImgLoading ? 0 : 100 }} />
                </div>
                {isImgLoading
                    ? <Loader/>
                    : <div className={style.titleRegister}>
                        {registerTitle && registerTitle}
                    </div>
                }
                <div className="steps-holder"></div>
            </div>
        </>
    );
};

export default MobileRegistrationHeader;
